export async function getClerkAuthToken() {
  let authorization = localStorage.getItem('clerk-auth-token');
  let i = 0;
  while (++i) {
    // if we have it, we are good to go
    if (authorization) return authorization;

    // back-off retury: .1s, .3s, .9s, 2.7s, max wait 3 second iteration between checks
    const timeout = Math.min(100 * 3 ** i, 3000);

    // Sleep for the timeout duration
    await new Promise((resolve) => setTimeout(resolve, timeout));

    // check again to see if it has been set yet
    authorization = localStorage.getItem('clerk-auth-token');
  }
}

export async function setClerkAuthToken(token: string) {
  // Store the token in localStorage
  localStorage.setItem('clerk-auth-token', token ?? '');

  // remove it if it is empty
  if (!token) localStorage.removeItem('clerk-auth-token');
}

export function clearClerkAuthToken() {
  setClerkAuthToken('');
}
